import { InputStyles } from 'lib/interfaces/input-styles';

export default interface ThemeSerialized {
  borderRadius: string;
  borderRadiusModal: string;
  borderWidth: string;
  buttonBackgroundImage: string;
  buttonFontWeight: FontWeight;
  buttonPosition: ButtonPosition;
  buttonShadowStrength: number;
  buttonTextTransform: TextTransform;
  colorButtonPrimary: string;
  colorButtonSecondary: string;
  colorButtonSecondaryFill?: string;
  colorButtonPrimaryFillDisabled: string;
  colorButtonSecondaryFillDisabled: string;
  colorError: string;
  colorFont: string;
  colorFontButtonPrimary: string;
  colorFontButtonSecondary: string;
  colorFontSmall: string;
  colorFontTitle: string;
  colorIconHeader: string;
  colorInputBackground: string;
  colorInputBorder: string;
  colorFooterBackground: string;
  colorLink: string;
  colorDropdownBackground: string;
  colorDropdownOption: string;
  colorModalBackground: string;
  colorPrimary: string;
  colorProgressBar: string;
  colorSuccess: string;
  colorWarning: string;
  colorDivider: string;
  fontFamily: string;
  fontFamilyTitle: string;
  fontUrl: string;
  fontSizeBody: string;
  fontSizeHeader: string;
  fontSizeSmall: string;
  headerFontWeight: FontWeight;
  headerMarginBottom: string;
  iconColorPrimary: string;
  iconColorHighlight: string;
  iconColorStroke: string;
  iconColorBackground: string;
  // @deprecated -- only for old OptionVertical icon fill. New OptionVertical design just uses colorPrimary.
  iconColorGovernmentIdType: string;
  inputStyle: InputStyles;
  lineHeightBody: string;
  lineHeightHeader: string;
  lineHeightSmall: string;
  logoData: string;
  logoFilename: string;
  logoHeight: string;
  logoUrl: string;
  logoWidth: string;
  pageTransition: PageTransition;
  textAlign: TextAlign;
  textDecorationLineLink: TextDecorationLine;
  usStateInputMethod: UsStateInputMethod;
  navbarLogoDisplay: NavbarLogoDisplay;
  navbarLogoHeight: string;
  iconStyle: IconStyle;
  processingDisplayStyle: ProcessingDisplayStyle;
  verticalOptionsStyle: VerticalOptionsStyle;
  // VerifyGovernmentIdPromptView
  governmentIdPictographPosition?: PictographPosition;
  idBackPictographHeight?: string;
  idBackPictographUrl?: string;
  idFrontPictographHeight?: string;
  idFrontPictographUrl?: string;
  passportFrontPictographHeight?: string;
  passportFrontPictographUrl?: string;
  passportSignaturePictographHeight?: string;
  passportSignaturePictographUrl?: string;
  governmentIdSelectPictographHeight?: string;
  governmentIdSelectPictographUrl?: string;
  deviceHandoffTermsTextPosition?: TermsTextPosition;
  // VerifySelfiePromptView
  selfiePictographUrl?: string;
  selfiePictographHeight?: string;
  // stillfie
  selfieCenterPictographUrl?: string;
  selfieCenterPictographHeight?: string;
  selfieLeftPictographUrl?: string;
  selfieLeftPictographHeight?: string;
  selfieRightPictographUrl?: string;
  selfieRightPictographHeight?: string;
  // VerifyDocumentsPromptView
  documentPictographHeight?: string;
  documentPictographPosition?: PictographPosition;
  documentPictographUrl?: string;
  // VerifyFailedView
  failedPictographHeight?: string;
  failedPictographPosition?: PictographPosition;
  failedPictographUrl?: string;
  // VerifySuccessView
  successPictographHeight?: string;
  successPictographPosition?: PictographPosition;
  successPictographUrl?: string;
  // VerifyExitView
  exitPictographHeight?: string;
  exitPictographPosition?: PictographPosition;
  exitPictographUrl?: string;
  // Loading
  loadingPictographHeight?: string;
  loadingPictographUrl?: string;
  // VerifySupportCameraView
  cameraSupportPictographUrl?: string;
  cameraSupportPictographHeight?: string;
}

export enum PageTransition {
  None = 'none',
  Slide = 'slide',
  Fade = 'fade',
  SlideVertical = 'slide-vertical',
}

export enum TextTransform {
  None = 'none',
  Capitalize = 'capitalize',
  Uppercase = 'uppercase',
  Lowercase = 'lowercase',
}

export enum FontWeight {
  Light = '300',
  Regular = '400',
  Medium = '500',
  Bold = '700',
  Black = '900',
}

export enum ButtonPosition {
  Inline = 'inline',
  Bottom = 'bottom',
}

export enum UsStateInputMethod {
  Input = 'input',
  Select = 'select',
}

export enum TextAlign {
  Default = 'default',
  Start = 'start',
  Center = 'center',
}

export enum TextDecorationLine {
  None = 'none',
  Underline = 'underline',
}

export enum NavbarLogoDisplay {
  Start = 'start',
  Center = 'center',
  End = 'end',
  None = 'none',
}

export enum IconStyle {
  Default = 'default',
  None = 'none',
}

export enum ProcessingDisplayStyle {
  Default = 'default',
  Overlay = 'overlay',
}

export enum VerticalOptionsStyle {
  Default = 'default',
  Light = 'light',
  Button = 'button',
}

export enum PictographPosition {
  Start = 'start',
  Center = 'center',
}

export enum TermsTextPosition {
  AboveButton = 'above_button',
  BelowButton = 'below_button',
}
